import axios from 'axios';

const withAuth = (token, extra = {}) => ({
  withCredentials: true,
  headers: {
    ...(token ? { Authorization: `Bearer ${token}` } : {}),
    ...extra
  }
});

class EtlAdminService {
  constructor() {
    this.baseUrl = process.env.REACT_APP_API_URL || '';
  }

  async getOverview(token) {
    const res = await axios.get(`${this.baseUrl}/api/admin/etl/overview`, withAuth(token));
    return res.data.overview;
  }

  async getDashboard(token, params = {}) {
    const res = await axios.get(`${this.baseUrl}/api/admin/etl/dashboard`, {
      ...withAuth(token),
      params: { registeredOnly: 1, ...params }
    });
    return res.data;
  }

  async getGrid(token, params = {}) {
    const res = await axios.get(`${this.baseUrl}/api/admin/etl/grid`, {
      ...withAuth(token),
      params
    });
    return res.data;
  }

  async getConfigDetail(token, configId) {
    const res = await axios.get(`${this.baseUrl}/api/admin/etl/configs/${configId}`, withAuth(token));
    return res.data.detail;
  }

  async getConfigHistory(token, configId, params = {}) {
    const res = await axios.get(`${this.baseUrl}/api/admin/etl/configs/${configId}/history`, {
      ...withAuth(token),
      params
    });
    return res.data;
  }

  async getGlobalHistory(token, params = {}) {
    const res = await axios.get(`${this.baseUrl}/api/admin/etl/history`, {
      ...withAuth(token),
      params
    });
    return res.data;
  }

  async seedInventory(token) {
    const res = await axios.get(`${this.baseUrl}/api/admin/etl/inventory/seed`, withAuth(token));
    return res.data;
  }

  async runNow(token, configId) {
    const res = await axios.post(`${this.baseUrl}/api/admin/etl/configs/${configId}/run`, {}, withAuth(token));
    return res.data;
  }

  async disable(token, configId) {
    const res = await axios.post(`${this.baseUrl}/api/admin/etl/configs/${configId}/disable`, {}, withAuth(token));
    return res.data;
  }

  async enable(token, configId) {
    const res = await axios.post(`${this.baseUrl}/api/admin/etl/configs/${configId}/enable`, {}, withAuth(token));
    return res.data;
  }

  async register(token, configId) {
    const res = await axios.post(`${this.baseUrl}/api/admin/etl/configs/${configId}/register`, {}, withAuth(token));
    return res.data;
  }
}

export const etlAdminService = new EtlAdminService();
